





















import { Component, Prop, Vue,Emit } from 'vue-property-decorator';
import { ignoreTodoItem, todoItem,tagFinishedTodo } from '@/apis/todoList/todoList';
import { InterfaceCourseHomeData } from '@/utils/dictionary';
import { typeRedirect } from '@/utils/common';
import { Dialog, Notify } from 'vant'
import i18n from '@/lang/index';

@Component({
    components: {
    }
})
export default class TodoItem extends Vue {
  @Prop() itemData!: todoItem;
  private className = '';
  private iconColor = '#f5f5f5';
  private teacherTodoNumberMap = new Map()
    .set('3', '试题')
    .set('4', '作业')
    .set('6', '试卷');

  makeClass() {
    let iconClassName = '';
    let iconColor = '';
    switch (this.itemData.contenttype) {
      // [1=>'课件',2=>'资料',3=>'互动答题',4=>'作业',5=>'话题',6=>'测试',7=>'公告',];
      case '1':
        iconClassName = require('@/assets/images/icons/ic-kejian.png');
        iconColor = '#00CA90';
        break;
      case '2':
        iconClassName = require('@/assets/images/icons/ic-ziliao.png');
        iconColor = '#71D516';
        break;
      case '3':
        iconClassName = require('@/assets/images/icons/ic-hudong.png');
        iconColor = '#FF941F';
        break;
      case '4':
        iconClassName = require('@/assets/images/icons/ic-zuoye.png');
        iconColor = '#31CCD2';
        break;
      case '5':
        iconClassName = require('@/assets/images/icons/ic-huati.png');
        iconColor = '#FFB607';
        break;
      case '6':
        iconClassName = require('@/assets/images/icons/ic-ceshi.png');
        iconColor = '#FFDA09';
        break;
      case '7':
        iconClassName = require('@/assets/images/icons/ic-gonggao.png');
        iconColor = '#6642F4';
        break;
    }
    this.className = iconClassName;
    this.iconColor = iconColor;
  }

  /**
   * 手动标记成已完成
   */
  tagFinishedItem(){
    let that = this;
    Dialog.confirm({
        title: i18n.t('Common.提示') as string,
        message: "是否标记成已完成？",
        confirmButtonText: i18n.t('Common.确定') as string,
        cancelButtonText: i18n.t('Common.取消') as string,
    })
    .then(() => {
      tagFinishedTodo({
        classid: this.itemData.courseid,
        contentid: this.itemData.contentid,
        contenttype: this.itemData.contenttype,
        msgtype: this.itemData.msgtype
      }).then(() => {
        that.$emit('tagFinished',this.itemData);
      }).catch(e => {
          console.log(e);
      });
    })
    .catch(() => {
      // on cancel
    })
  }

  ignoreItem() {
    const params = {
      classid: this.itemData.courseid,
      contentid: this.itemData.contentid,
      contenttype: this.itemData.contenttype,
      msgtype: this.itemData.msgtype
    };
    ignoreTodoItem(params)
      .then(() => {
        this.$emit('todoItemIgnored');
      })
      .catch(e => {
        console.log(e);
      });
  }

  onGoCreate(type: keyof InterfaceCourseHomeData) {
    const { courseid, msgtype } = this.itemData;
    window.sessionStorage.setItem('courseId', courseid);
    typeRedirect.call(this, type, {
      courseId: courseid,
      courseRole: String(msgtype) === '1' ? '0' : '1',
      // @ts-ignore
      dataInfo: {
        id: this.itemData.contentid
      }
    });
  }

  created() {
    this.makeClass();
  }
}
